export const GMV = 'GMV';
export const UNITS = 'Units';
export const NETSALES = 'Net Sales';
export const CHANNEL_BREAKDOWN = 'Channel Breakdown';
export const NET_SALES_CHANNEL = 'Net Sales by Channel';
export const UNITS_CHANNEL = 'Units by Channel';
export const THIS_YEAR = 'This year';
export const LAST_YEAR = 'Last year';
export const STORE = 'Store';
export const IN_STORE = 'In-Store';
export const OMNI = 'Omni';
export const OMNICHANNEL = 'OmniChannel';
export const ECOM = 'eCom';
export const ECOMMERCE = 'eCommerce';
export const CATEGORY = 'Category';
export const ONHAND_INVENTORY = 'On-Hand';
export const TOTAL = 'Total';
export const DC = 'DC';
export const INTRANSIT_INVENTORY = 'In-Transit';
export const ON_ORDER = 'On Order';
export const ON_ORDER_HYPHEN = 'On-Order';
export const ON_ORDER_STORE = 'On-order Store';
export const WAREHOUSE = 'In WHSE';
export const ON_ORDER_DC = 'On-order DC';
export const DC_TO_STORE = 'DC to Store';
export const INVENTORY_TRENDS = 'Inventory Trends';
export const INVENTORY_TRENDS_SUB_HEADER = 'Net Sales v/s On-hand Inventory';
export const INVENTORY_TOAST_MESSAGE =
	'All data reflects physical inventory for Store consumptions. Distribution Center Data will be added at a later date.';
export const REPO_METRICS_HEADING =
	'What type of report metrics are you most interested in?';
export const REPO_METRICS_SUBHEADING =
	'You can update your preferences from your Profile at any time!';
export const INSIGHT_SALES = 'Sales Weekly Insights';
export const INSIGHT_INVENTORY = 'Inventory Weekly Insights';
export const DEPARTMENT_INSIGHTS = 'Weekly Insights';
export const SELECTED_INSIGHTS = 'Selected Insights';
export const FFEDBACK_MSG = 'Great, thanks for your feedback!';
export const DRAWER_FOOTER = 'Was this insight helpful?';
export const INSIGHTS = 'Insights';
export const ALL_INSIGHTS = 'All Insights';
export const YES = 'Yes';
export const NO = 'No';
export const INSIGHTS_WHAT = "What we're seeing";
export const INSIGHTS_WHY = 'What could be the cause';
export const INSIGHTS_WHERE = "Where we're seeing this";
export const INSIGHTS_FEEDBACK = "Why wasn't this helpful?";
export const INSIGHTS_FEEDBACK_MSG_ONE = 'Tell us more...';
export const INSIGHTS_FEEDBACK_MSG_TWO =
	'Your feedback helps to improve future insights';
export const SUBMIT_FEEDBACK = 'Submit feedback';
export const ONHANDINVENTORY = 'OnHandInventory';
export const EXCEL_ONHAND_INVENTORY = 'On Hand Inventory';
export const INTRANSITINVENTORY = 'InTransitInventory';
export const EXCEL_INTRANSIT_INVENTORY = 'In Transit Inventory';
export const THIS_WEEK = 'This week';
export const PREVIOUS_WEEK = 'Previous week';
export const PREVIOUS_INSIGHTS = 'Previous Insights';
export const NO_INSIGHTS_MSG = 'You do not have any new insights today';
export const NO_SALES_INSIGHTS_MSG =
	'Currently there are no sales insights available';
export const NO_INVENTORY_INSIGHTS_MSG =
	'Currently there are no inventory insights available';
export const INVENTORY_INSIGHTS = 'Inventory Insights';
export const NO_INSIGHTS = 'No anomalous deviations detected for the';
export const WHAT_IS_INSIGHTS = 'What are Insights?';
export const EXPLORE = 'Explore';
export const ITEM_PERFORMANCE = 'Item Performance';
//For now we are making the same error message here
export const ERROR_SCREEN_MSG_STORE =
	'data is not loading. The technical team is working to resolve the issue. Please check back soon. Contact Scintilla Support for further details.';
export const DATA_NOT_AVAILABLE =
	'data is not available for the business hierarchy & timeframe combination. Please change the filters to look at the metric for a different time period.';
export const API_FAILURE_MSG =
	'- Something went wrong, please check back in sometime';
export const DATA_NOT_LOADING_MSG =
	'data is not loading. We are working on it, please check back in sometime. Contact Scintilla support for further details.';
export const INVENTORY_ITEM_DATA_NOT_AVAILABLE =
	'Store Inventory data is not available. Please change the time filter or verify if the selected item is not an eCommerce only item.';
export const REPLENISHMENT_DATA_NOT_AVAILABLE =
	'Replenishment data is not available. Please verify if the selected item is not an eCommerce only item.';
export const SUMMARY_CARD_DATA_NOT_AVAILABLE = 'Data not available for item.';
export const ITEM_DATA_NOT_AVAILABLE =
	'data is not available. Please verify if the selected item is not an eCommerce only item.';

export const INTRANSIT = 'In-transit';
export const RETAIL = 'Retail($)';
export const UNIT = 'Units(#)';
export const IN_STOCK = 'In Stock';
export const REPL_IN_STOCK = 'Repl Instock %';
export const IN_STOCK_HYPEN = 'In-Stock';
export const INSTOCKINVENTORY = 'InStockInventory';
export const EXCEL_INSTOCK_INVENTORY = 'In Stock Inventory';
export const BIS = 'Buy in Store';
export const PICKUP = 'Pick Up';
export const DELIVERY = 'Delivery';
export const SFS = 'Ship from Store';
export const S2S = 'Ship to Store';
export const S2H = 'Ship to Home';
export const BOGLE_MEDIUM = 'Bogle-medium';
export const SUB_CATEGORY_TAB = 'Sub-Category';
export const USA = 'United States of America';
export const BOGLE_REGULAR = 'Bogle-Regular';
export const BOGLE_LIGHT = 'Bogle-Light';
export const BOGLE_BOLD = 'Bogle-Bold';
export const INLINE_BLOCK = 'inline-block';
export const DRILLDOWN_ROUTE = '/drilldown';
export const ITEM_DESCRIPTION = 'Item Description';
export const STORE_TYPE = 'Store Type';
export const STORE_NUMBER = 'Store Number #';
export const ONHAND_UNIT = 'On-Hand Units';
export const NIL_PICK_RATE = 'Nil Pick Rate(%)';
export const FIRST_TIME_PICK_RATE = 'First Time Pick Rate(%)';
export const PRE_SUBSITUTE_RATE = 'Pre Substitute Rate(%)';
export const POST_SUBSITUTE_RATE = 'Post Substitute Rate(%)';
export const ABSOLUTE = 'Absolute($)';
export const YOYCHANGE = 'YOY Change($)';
export const STORE_COUNT = 'Valid Store Count';
export const EDIT_PREFERENCES = 'Edit preferences';
export const ON_HAND_INVENTORY = 'On Hand Inventory';
export const IN_STOCK_INVENTORY = 'In Stock Inventory';
export const ON_ORDER_INVENTORY = 'On Order';
export const DC_TO_STORE_INVENTORY = 'DC To Store';
export const IN_WHSE_INVENTORY = 'In WHSE';
export const UNITSBYCHANNEL = 'Units By Channel';
export const NETSALESBYCHANNEL = 'Net Sales By Channel';
export const NEED_TO_BE_SELECTED = 'Needs to be selected';
export const THRESHOLD = 'Threshold';
export const COMPARISON = 'Comparison';
export const clearButton = 'Clear list';
export const customRulePollDelay = 20000;
export const YOU_HAVE_UNREAD_NOTIFICATIONS = 'You have unread notifications';
export const VIEW_NOTIFICATION = 'View Notification';
export const CREATE_RULE = 'Create Rule';
export const EDIT_RULE = 'Edit Rule';
export const CONFIRM_DELETE_TITLE = 'Delete Rule?';
export const CONFIRM_DELETE_DESCRIPTION =
	'You will no longer receive notifications for this rule.';
export const CUSTOM_TABLE_COLUMN = 'Custom Table Column';
export const CUSTOM_TABLE_COLUMNS = 'Custom Table Columns';
export const DOWNLOAD_EXCEL = 'Download in .xlsx';
export const SAVE = 'Save';
export const CANCEL = 'Cancel';
export const DELETE = 'Delete';
export const DATE_2022_12_09 = '2022-12-09';
export const DATE_2022_12_08 = '2022-12-08';
export const DATE_2022_12_07 = '2022-12-07';
export const DATE_2022_12_06 = '2022-12-06';
export const DATE_2022_12_05 = '2022-12-05';
export const DATE_2022_12_04 = '2022-12-04';
export const DATE_2022_12_03 = '2022-12-03';
export const ITEM_NUMBER = 'Item Number';
export const WOS_SUMMARY_KEY = 'Total WOS Average';
export const RULE_NOTIFICATIONS = 'Rule Notifications';
export const US_LOCALE = 'en-US';
export const DOLLAR_SIGN = '$';
export const NEGETIVE_DOLLAR_SIGN = '-$';
export const HYPEN = '-';

export const WOS_TAB_KEY_STORE = {
	0: 'ON_HAND',
	1: 'ON_ORDER',
	2: 'IN_WHSE',
	3: 'IN_TRANSIT',
};

export const WOS_TAB_KEY_DC = {
	0: 'TOTAL',
	1: 'ON_HAND',
	2: 'ON_ORDER',
};

export const LEGENDS = {
	ECOM: 'eCom',
	STORE: 'Store',
	BIS: BIS,
	PICKUP: PICKUP,
	DELIVERY: DELIVERY,
	SFS: SFS,
	S2S: S2S,
	S2H: S2H,
};
export const GRID_DISTANCE = {
	'-1': [0, 1],
	0: [0, 1],
	1: [0, 1],
	4: [0, 1],
	13: [-1, 1],
	26: [-2, 2],
	52: [-5, 2],
};

export const DONUT_VALUES = {
	0: 'netsales_value',
	1: 'sales_value',
	2: 'gmv_value',
};

export const ADOBE_URL = {
	prod: 'https://assets.adobedtm.com/54ac91b83be6/129d6c3d4b54/launch-3ee40c545cb2.min.js',
	'non-prod':
		'https://assets.adobedtm.com/54ac91b83be6/129d6c3d4b54/launch-5197731fa672-development.min.js',
};

export const SalesMetric = [
	{ value: 'netsales', label: 'Net Sales' },
	{ value: 'units', label: 'Units' },
	{ value: 'gmv', label: 'GMV' },
];
export const ReplenishmentMetric = [
	{ value: 'firstTimePickRate', label: 'First-time Pick Rate %' },
	{ value: 'nilPickRate', label: 'Nil Pick Rate %' },
	{ value: 'preSubRate', label: 'Pre substitute Rate %' },
	{ value: 'postSubRate', label: 'Post substitute Rate %' },
];

export const InventoryMetric = [
	{ value: 'onHand$', label: 'On Hand ($)' },
	{ value: 'onHandUnits', label: 'On Hand (Units)' },
	{ value: 'onOrder$', label: 'On Order ($)' },
	{ value: 'onOrderUnits', label: 'On Order (Units)' },
	{ value: 'dctostore$', label: 'DC To Store ($)' },
	{ value: 'dctostoreUnits', label: 'DC To Store (Units)' },
	{ value: 'storeInStock', label: 'Replenishable Instock %' },
	{ value: 'storeInWarehouse$', label: 'Store In Warehouse ($)' },
	{ value: 'storeInWarehouseUnits', label: 'Store In Warehouse (Units)' },
];

// Comparison for Net Sales/GMV and Inventory Retail

export const salesGMVSales = [
	{ value: 'netsales', label: 'Net Sales' },
	{ value: 'gmv', label: 'GMV' },
];

export const inventoryRetail = [
	{ value: 'onHand$', label: 'On Hand ($)' },
	{ value: 'onOrder$', label: 'On Order ($)' },
	{ value: 'dctostore$', label: 'DC To Store ($)' },
	{ value: 'storeInWarehouse$', label: 'Store In Warehouse ($)' },
];

// Comparison for Inventory Units
export const salesforInvunits = [{ value: 'units', label: 'Units' }];

export const inventoryforUnits = [
	{ value: 'onHandUnits', label: 'On Hand (Units)' },
	{ value: 'dctostoreUnits', label: 'DC To Store (Units)' },
	{ value: 'storeInWarehouseUnits', label: 'Store In Warehouse (Units)' },
];

// Comparison between Instock %
export const inventoryforinStock = [
	{ value: 'storeInStock', label: 'Replenishable Instock %' },
];

// Comparison for OPD use ReplenishmentMetric

// Comparison for Sales Units use salesforInvunits and below

export const inventoryforAllUnits = [
	{ value: 'onHandUnits', label: 'On Hand (Units)' },
	{ value: 'onOrderUnits', label: 'On Order (Units)' },
	{ value: 'dctostoreUnits', label: 'DC To Store (Units)' },
	{ value: 'storeInWarehouseUnits', label: 'Store In Warehouse (Units)' },
];

export const displayMetric = {
	netsales: 'Net Sales',
	units: 'Units',
	gmv: 'GMV',
	onHand$: 'On Hand ($)',
	onHandUnits: 'On Hand (Units)',
	onOrder$: 'On Order ($)',
	onOrderUnits: 'On Order (Units)',
	dctostore$: 'DC To Store ($)',
	dctostoreUnits: 'DC To Store (Units)',
	storeInStock: 'Replenishable Instock %',
	storeInWarehouse$: 'Store In Warehouse ($)',
	storeInWarehouseUnits: 'Store In Warehouse (Units)',
	nilPickRate: 'Nil Pick Rate %',
	preSubRate: 'Pre substitute Rate %',
	postSubRate: 'Post substitute Rate %',
	firstTimePickRate: 'First-time Pick Rate %',
};

export const measures = {
	netsales: 'NET_SALES',
	units: 'UNITS',
	gmv: 'GMV',
	onHand$: 'STORE_ON_HAND_AMT',
	onHandUnits: 'STORE_ON_HAND_UNITS',
	onOrder$: 'STORE_ON_ORDER_AMT',
	onOrderUnits: 'STORE_ON_ORDER_UNITS',
	dctostore$: 'STORE_DC_TO_STORE_AMT',
	dctostoreUnits: 'STORE_DC_TO_STORE_UNIT',
	storeInStock: 'INSTOCK_PERCENTAGE',
	nilPickRate: 'NIL_PICK_RATE_PERCENTAGE',
	preSubRate: 'PRE_SUBS_RATE_PERCENTAGE',
	postSubRate: 'POST_SUBS_RATE_PERCENTAGE',
	firstTimePickRate: 'FIRST_TIME_PICK_RATE_PERCENTAGE',
	storeInWarehouse$: 'STORE_IN_WAREHOUSE_AMT',
	storeInWarehouseUnits: 'STORE_IN_WAREHOUSE_UNIT',
};

export const metricDomain = {
	netsales: 'SALES',
	units: 'SALES',
	gmv: 'SALES',
	onHand$: 'INVENTORY',
	onHandUnits: 'INVENTORY',
	onOrder$: 'INVENTORY',
	onOrderUnits: 'INVENTORY',
	dctostore$: 'INVENTORY',
	dctostoreUnits: 'INVENTORY',
	storeInStock: 'INVENTORY',
	storeInWarehouse$: 'INVENTORY',
	storeInWarehouseUnits: 'INVENTORY',
	nilPickRate: 'REPLENISHMENT',
	preSubRate: 'REPLENISHMENT',
	postSubRate: 'REPLENISHMENT',
	firstTimePickRate: 'REPLENISHMENT',
};

export const channelOptionMapping = {
	Omni: 'OMNI',
	Store: 'STORE',
	eComm: 'ECOM',
};

export const StoreChannel = [
	{ name: 'BIS', value: 'Buy in Store' },
	{ name: 'PICKUP', value: 'Pickup' },
	{ name: 'DELIVERY', value: 'Delivery' },
	{ name: 'SFS', value: 'Ship from Store' },
];

export const OmniChannel = [
	{ name: 'BIS', value: 'Buy in Store' },
	{ name: 'PICKUP', value: 'Pickup' },
	{ name: 'DELIVERY', value: 'Delivery' },
	{ name: 'SFS', value: 'Ship from Store' },
	{ name: 'S2S', value: 'Ship to Store' },
	{ name: 'S2H', value: 'Ship to Home' },
];

export const eComChannel = [
	{ name: 'S2S', value: 'Ship to Store' },
	{ name: 'S2H', value: 'Ship to Home' },
];

export const productHierarchyType = {
	Item: 'ITEM',
	Category: 'CATEGORY',
	Department: 'DEPARTMENT',
	Brand: 'BRAND',
	UPC: 'UPC',
	Subcategory: 'SUBCATEGORY',
};

export const productFilters = {
	UPC: 'wmUpcNbr',
	ITEM: 'itemId',
	CATEGORY: 'catId',
	SUBCATEGORY: 'subCatId',
	BRAND: 'brandName',
	DEPARTMENT: 'deptId',
};

export const measureList = [
	{ name: 'ABSOLUTE_VALUE', value: 'Absolute Value' },
	{ name: 'YOY_CHANGE', value: 'YoY' },
	{ name: 'YOY_CHANGE_PERCENTAGE', value: 'YoY (%)' },
	{ name: 'WOW_CHANGE', value: 'WoW' },
	{ name: 'WOW_CHANGE_PERCENTAGE', value: 'WoW (%)' },
];

export const measureListB = [
	{ name: 'ABSOLUTE_VALUE', value: 'Absolute Value' },
	{ name: 'WOW_CHANGE', value: 'WoW' },
];

export const aggregationList = [
	{ name: 'DAILY', value: 'Daily' },
	{ name: 'WEEKLY', value: 'Weekly' },
	{ name: 'LAST_4_WEEKS', value: 'Last 4 weeks' },
	{ name: 'LAST_13_WEEKS', value: 'Last 13 weeks' },
	{ name: 'LAST_26_WEEKS', value: 'Last 26 weeks' },
	{ name: 'LAST_52_WEEKS', value: 'Last 52 weeks' },
	{ name: 'WEEK_TO_DATE', value: 'Week to Date' },
	{ name: 'YEAR_TO_DATE', value: 'Year to Date' },
];

export const aggregationListB = [
	{ name: 'DAILY', value: 'Daily' },
	{ name: 'WEEK_TO_DATE', value: 'Week to Date' },
];

export const locationArr = [
	{ name: 'STORES', value: 'Specific Store' },
	{ name: 'STATES', value: 'Specific State' },
	{ name: 'USA', value: 'Entire United States' },
];

export const hierarchyArr = [
	'Item',
	'Category',
	'Department',
	'Brand',
	'UPC',
	'Subcategory',
];

export const states = [
	{ name: 'WY', value: 'Wyoming' },
	{ name: 'WV', value: 'West Virginia' },
	{ name: 'WI', value: 'Wisconsin' },
	{ name: 'WA', value: 'Washington' },
	{ name: 'VT', value: 'Vermont' },
	{ name: 'VA', value: 'Virginia' },
	{ name: 'UT', value: 'Utah' },
	{ name: 'TX', value: 'Texas' },
	{ name: 'TN', value: 'Tennessee' },
	{ name: 'SD', value: 'South Dakota' },
	{ name: 'SC', value: 'South Carolina' },
	{ name: 'RI', value: 'Rhode Island' },
	{ name: 'PA', value: 'Pennsylvania' },
	{ name: 'OR', value: 'Oregon' },
	{ name: 'OK', value: 'Oklahoma' },
	{ name: 'OH', value: 'Ohio' },
	{ name: 'NY', value: 'New York' },
	{ name: 'NV', value: 'Nevada' },
	{ name: 'NM', value: 'New Mexico' },
	{ name: 'NJ', value: 'New Jersey' },
	{ name: 'NH', value: 'New Hampshire' },
	{ name: 'NE', value: 'Nebraska' },
	{ name: 'ND', value: 'North Dakota' },
	{ name: 'NC', value: 'North Carolina' },
	{ name: 'MT', value: 'Montana' },
	{ name: 'MS', value: 'Mississippi' },
	{ name: 'MO', value: 'Missouri' },
	{ name: 'MN', value: 'Minnesota' },
	{ name: 'MI', value: 'Michigan' },
	{ name: 'ME', value: 'Maine' },
	{ name: 'MD', value: 'Maryland' },
	{ name: 'MA', value: 'Massachusetts' },
	{ name: 'LA', value: 'Louisiana' },
	{ name: 'KY', value: 'Kentucky' },
	{ name: 'KS', value: 'Kansas' },
	{ name: 'IN', value: 'Indiana' },
	{ name: 'IL', value: 'Illinois' },
	{ name: 'ID', value: 'Idaho' },
	{ name: 'IA', value: 'Iowa' },
	{ name: 'HI', value: 'Hawaii' },
	{ name: 'GA', value: 'Georgia' },
	{ name: 'FL', value: 'Florida' },
	{ name: 'DE', value: 'Delaware' },
	{ name: 'DC', value: 'District of Columbia' },
	{ name: 'CT', value: 'Connecticut' },
	{ name: 'CO', value: 'Colorado' },
	{ name: 'CA', value: 'California' },
	{ name: 'AZ', value: 'Arizona' },
	{ name: 'AR', value: 'Arkansas' },
	{ name: 'AL', value: 'Alabama' },
	{ name: 'AK', value: 'Alaska' },
	{ name: 'PR', value: 'Puerto rico' },
];

export const chartMetricType = ['cbSalesData', 'cbUnitsData'];
export const SELECTED_STORE = 'Selected stores';
export const SELECTED_ITEM = 'Selected items';
export const SELECTED_CATEGORIES = 'Selected categories';
export const SELECTED_DEPARTMENTS = 'Selected departments';
export const SELECTED_BRANDS = 'Selected brands';
export const SELECTED_UPC = 'Selected UPC';
export const SELECTED_SUBCATEGORY = 'Selected Sub-categories';
export const SUBCATEGORY = 'Sub-category';
export const SUB_CATEGORY = 'Sub-Category';
export const LEFT_START = 'left-start';
export const SALES_METRIC = 'Sales Metric';
export const INVENTORY_METRIC = 'Store Inventory Metric';
export const SPACE_BETWEEN = 'space-between';
export const ALL_CHANNELS = ['BIS', 'PICKUP', 'DELIVERY', 'SFS', 'S2S', 'S2H'];
export const CP = 'Channel Performance';

export const errorStatusSaveHierarchy = {
	NO_ERROR: '',
	NAME_EXIST: 'Name already exists. Please give another name.',
	LENGTH_EXCEEDED: 'The name cannot be longer than 255 characters.',
	NO_NAME: 'Give a name to this hierarchy.',
};

export const MAX_UPC_LIMIT = 200;
export const COPY_PASTE_REGEX = /^[a-zA-Z0-9]*$/i;

export const SAVE_HIERARCHY_ERROR_MESSAGE = 'Can’t save hierarchy.';
export const SAVE_HIERARCHY_SUCCESS =
	'Custom hierarchy is applied successfully';
export const SAVE_HIERARCHY_SUCCESS_DEFAULT =
	'The hierarchy is saved and set as the default.';

/* TABLE FILTERS */

export const DEPARTMENT = 'Department';
export const ITEM = 'Item';
export const BRAND = 'Brand';
export const STATE = 'State';
export const SUB_DIVISION = 'Sub-division';
export const REGION = 'Region';
export const MARKET = 'Market';
export const PRIME_ITEM_NUMBER = 'Prime Item Number';
export const ALL_LINK_NUMBER = 'All Links Number';
export const FINELINE = 'Fineline';
export const BREAKDOWN_BY = 'Breakdown by';
export const VIEW_BY = 'View by';
export const COMPARISON_TIME_PERIOD = 'Comparison time period';
export const LAST_WMT_WEEK = 'Last WMT Week';
export const LAST_4_WMT_WEEK = 'Last 4 WMT Weeks';
export const LAST_13_WMT_WEEK = 'Last 13 WMT Weeks';
export const LAST_26_WMT_WEEK = 'Last 26 WMT Weeks';
export const LAST_52_WMT_WEEK = 'Last 52 WMT Weeks';
export const LAST_WMT_WEEK_SHORT = 'L WMT wk';
export const LAST_4_WMT_WEEK_SHORT = 'L4 WMT wks';
export const LAST_13_WMT_WEEK_SHORT = 'L13 WMT wks';
export const LAST_26_WMT_WEEK_SHORT = 'L26 WMT wks';
export const LAST_52_WMT_WEEK_SHORT = 'L52 WMT wks';
export const SET_TO_DEFAULT = 'Set to default';
export const SELECT_ONE = 'Select one';
export const SELECT_ONE_OR_MULTIPLE = 'Select one or multiple';
export const WMT_WEEK_TO_DATE = 'WMT Week to Date';
export const WTD = 'WTD';
export const CUSTOM = 'Custom';

/* Graph QL */
export const GraphQLAuthHeader = 'LOCALHOST_TESTING_TOKEN_123456789';

export const VIEWBY_ENUMS = Object.freeze({
	SUB_DIVISION: 'SUB_DIVISION',
	REGION: 'REGION',
	MARKET: 'MARKET',
	PRIME_ITEM_NUMBER: 'PRIME_ITEM_NUMBER',
	ALL_LINK_NUMBER: 'ALL_LINK_NUMBER',
	FINELINE: 'FINELINE',
	DEPARTMENT: 'DEPARTMENT',
	SUBCATEGORY: 'SUBCATEGORY',
	CATEGORY: 'CATEGORY',
	STORE: 'STORE',
	ITEM: 'ITEM',
	STATE: 'STATE',
	BRAND: 'BRAND',
	SET_TO_DEFAULT: '',
});

export const TIME_PERIOD_ENUMS = Object.freeze({
	WTD: 'WTD',
	LW: 'LW',
	L2W: 'L2W',
	L4W: 'L4W',
	L13W: 'L13W',
	L26W: 'L26W',
	L52W: 'L52W',
	CUSTOM: 'CUSTOM',
});

export const walmartWeekMap = {
	0: 'WMT Week to Date',
	1: 'WMT Last Week',
	4: 'WMT Last 4 Weeks',
	13: 'WMT Last 13 Weeks',
	26: 'WMT Last 26 Weeks',
	52: 'WMT Last 52 Weeks',
	'-1': 'Custom',
};

export const HIERARCHY_APPLIED_SUCCESSFULLY =
	'This change is applied successfully';

export const enumToColumnNames = {
	NET_SALES: 'Net Sales',
	UNITS: 'Units',
	AUR: 'AUR',
	S2H: 'Ship To Home',
	S2S: 'Ship To Store',
	SFS: 'Ship From Store',
	DELIVERY: 'Delivery',
	PICKUP: 'Pick up',
	BIS: 'Buy In Store',
	STORE_ON_HAND: 'Store On Hand Quantity',
	STORE_ON_ORDER: 'Store On Order Quantity',
	STORE_DC_TO_STORE: 'Store In Transit Quantity',
	STORE_IN_WHSE: 'Store In Warehouse Quantity',
	TOTAL_STORE_INVENTORY: 'Total Store Inventory',
	POST_SUB_RATE: 'Post Substitute Rate',
	PRE_SUB_RATE: 'Pre Substitute Rate',
	FTPR: 'First Time Pick Rate',
	NPR: 'Nil Pick Rate',
	TOQ: 'Total Order Quantity',
	PRE_SUB_QTY: 'Pre Substitute Quantity',
	SUB_QTY: 'Substitute Quantity',
	NIL_PIC_QUANTITY: 'Nil Pick Quantity',
	STORE_IN_STOCK_PERCENTAGE: 'Repl Instock %',
	TRAITED_STORE_COUNT: 'Traited Store Count',
	TRAITED_ITEM_COUNT: 'Traited Item Count',
	VALID_STORE_COUNT: 'Valid Store Count',
	DOLLARSW: 'Dollar/Store/Week(Day)',
	UNITSW: 'Units/Store/Week(Day)',
};

export const CATMANVIEW = 'Category advisor view';
export const STANDARDVIEW = 'Standard user view';
export const PERSONAVIEW = Object.freeze({
	CATMAN: 'CATMAN',
	SUPPLIER: 'SUPPLIER',
});

// POWERED AI
export const AI_INSIGHTS = 'Guided Insights';
export const DASHBOARD = 'Dashboard';
export const LEARN_MORE_ANOMALY_TEXT =
	'Learn more about anomalies and how they are calculated';
export const ANOMALY_OVERVIEW = 'Anomaly Overview';
export const ANOMALY_OUTPERFORMING = 'Anomaly-Outperforming';
export const ANOMALY_UNDERPERFORMING = 'Anomaly-Underperforming';
export const INLINE = 'In Line';
export const ALERT_BUTTON = 'Dont show again';
export const ALERT_MESSAGE =
	'Currently AI-powered insights are only enabled for store channel and only for at least 4 weeks’ time windows. More to come in the future!';
export const ANOMALY_DETAILS = 'anomaly-details-and-root-cause';
export const OUTPERFORMING = 'OUTPERFORMING';
export const UNDERPERFORMING = 'UNDERPERFORMING';
export const ALL = 'ALL';
export const INVENTORY_HEALTH = 'inventoryHealth';
export const PRICING_CHANGE = 'pricing';
export const POINTS_OF_DISTRIBUTION = 'pod';
export const ASSORTMENT_CONFIGURATION = 'assortment';
export const NOT_IDENTIFIED = 'notidentified';
export const ROOT_CAUSE_WARNING_TEXT =
	'The root causes are ordered based on the potential sales impact';
export const POTENIAL_SALES_IMPACT = 'Potential Sales Impact';
export const POD = 'pod';
export const INVENTORY = 'inventory';
export const ASSORTMENT = 'assortment';
export const PRICING = 'pricing';

export const ADDED = 'added';
export const REMOVED = 'removed';
export const INVALID_HIERARCHY =
	'Your hierarchy selections are all eCommerce only. Please select at least one store level hiererchy.';
export const PARTIAL_HIERARCHY =
	'eCommerce-only hierarchy levels are not considered for analysis.';

export const MAIN_INSIGHTS_DASHBOARD = 'Main Dashboard';
export const GUIDED_INSIGHTS_HOME = 'Guided_Insights_Home';
export const GUIDED_INSIGHTS_RCA = 'Guided_Insights_RCA';
export const CUSTOM_ATTRIBUTE = 'Custom Attribute';
export const WALMART_ATTRIBUTE = 'Walmart Attribute';
export const STORE_DRILL_DOWN_PAGE = 'Store Drill Down Page';

export const CANNED_TIME_WINDOW_SELECTED = 'Canned Time Window Selected';
export const CHANGE_TIME_SELECTION = 'Change Time Selection';
export const CANNED_TIME_WINDOW_SELECTION = 'Canned Time Window Selection';
export const TIME_SELECTION = 'Time Selection';
export const ITEM_SELECTED = 'Item Selected';
export const ITEM_SELECTED_TEXT = 'Item Selection - Item:';
export const STORE_DRILL_DOWN_PAGE_LAUNCHED = 'Store Drill Down Page Launched';
export const RCA_REPLINSIHMENT_TEXT =
	'RCA Replenishment Health - Stores with Rpl. Instock % < 95% :';

export const comparisonError = {
	NO_DATA: 'No Data',
	NO_COMPARE_DATA: 'No Compare Data',
	NO_DATA_MESSAGE: 'No data available',
	NO_DATA_SUB_MESSAGE: 'Select different metrics to try again.',
	NO_COMPARE_DATA_MESSAGE: 'The chart isn’t loading correctly',
	NO_COMPARE_DATA_SUB_MESSAGE: 'Try selecting a metric again.',
};

export const WMT_ATTR = 'WMT_ATTR';
export const CUSTOM_ATTR = 'CUSTOM_ATTR';
export const WMT_ATTR_LEVEL = 'wmtAttrLevel';
export const CUSTOM_ATTR_LEVEL = 'customAttrLevel';

export const performanceSummary = {
	SUPPLIER_SHARE: 'Supplier Share',
	NET_SALES: 'Net Sales',
	UNITS: 'Units',
	AVG_NILPICK: 'Avg NilPick %',
	VS_PREVIOUS_PRD: 'vs Previous Period',
	WMT: 'WMT',
};

export const STORE_DRILLDOWN_HEADER_TEXT =
	'Stores with Replenishable InStock% < ';

// Store drilldown table columns
export const DC_INFORMATION = 'DC Information';
export const DC_NUMBER = 'DC Number';
export const DC_NAME = 'DC Name';
export const REPL_INSTOCK_PCT = 'Replenishment Instock %';
export const STORE_ON_HAND = 'Store On Hand';
export const STORE_ON_ORDER = 'Store On Order';
export const STORE_IN_TRANSIT = 'Store In Transit';
export const STORE_IN_WAREHOUSE = 'Store In Warehouse';
export const DC_ON_HAND = 'DC On Hand';
export const DC_ON_ORDER = 'DC On Order';
export const SALES = 'Sales';
export const NILPICK_PCT = 'NilPick %';
export const NILPICK_QUANTITY = 'NilPick Quantity';
export const STORE_WEEKS_OF_SUPPLY = 'Store Weeks of Supply - On Hand';
export const UNIT_STORE_WEEK = 'Units / Store / Week';
export const DOLLAR_STORE_WEEK = 'Dollar / Store  / Week';
export const DC_WEEKS_OF_SPLY_ON_HAND = 'DC Weeks of Supply - On Hand';

// Store drill down download
export const AG_GRID_AUTOCOL = 'ag-Grid-AutoColumn';
export const DOWNLOAD_REQUEST_EVENT = 'Download';
export const DOWNLOAD_REQUEST_EVENT_DESC_ROOTCAUSE =
	'Store Drilldown .Xlsx report';

export const STORE_DRILL_DOWN_NO_DATA =
	'No Stores found with selected replenishment for Selected week filter.';